module.exports = __webpack_public_path__ + "img/whatsapp.2f487a1b.png";